var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"custom-image"}},[_c('div',{attrs:{"id":"container"}},[_c('img',{attrs:{"id":"image","src":_vm.imagePath,"alt":_vm.info}}),_vm._v(" "),_c('h2',{staticClass:"caption"},[_vm._v(_vm._s(_vm.info))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bdb4c8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomImage.vue
// module id = 62
// module chunks = 0